export type ValidationRule =
  | "isRequired"
  | "isEmail"
  | "isNumber"
  | "isNotEmptyArray"
  | "isBoolean"
  | { type: "isBetween"; min: number; max: number };

export type ValidatableValue = string | number | boolean | null | undefined | string[] | Date;

export const validationRules: Record<
Exclude<ValidationRule, { type: "isBetween"; min: number; max: number }>,
(value: ValidatableValue) => boolean
> = {
  isRequired: (value) => {
    if (value === null || value === undefined) { return false; }
    if (typeof value === "string") { return value.trim() !== ""; }
    if (typeof value === "number") { return !Number.isNaN(value); }
    if (Array.isArray(value)) { return value.length > 0; }
    return true;
  },

  isEmail: (value) => typeof value === "string" &&
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),

  isNumber: (value) => typeof value === "number" && !Number.isNaN(value),

  isNotEmptyArray: (value) => Array.isArray(value) && value.length > 0,

  isBoolean: (value) => typeof value === "boolean",
};

export const getFieldDisplayName = <T extends string>(
  fieldKey: T,
  fieldNameMap: Record<T, string>,
): string => fieldNameMap[fieldKey] || fieldKey;

export const validationMessages: Record< Exclude<ValidationRule, { type: "isBetween"; min: number; max: number }>, (fieldName?: string) => string> = {
  isRequired: (fieldName) => (fieldName ? `${fieldName} is required` : "This field is required"),
  isEmail: () => "Please enter a valid email address",
  isNumber: () => "Please enter a valid number",
  isNotEmptyArray: () => "Please select at least one option",
  isBoolean: () => "Please select a valid option",
};
export function validateDynamicRule(
  rule: ValidationRule,
  value: ValidatableValue,
): string | null {
  if (typeof rule === "object" && rule.type === "isBetween") {
    const num = typeof value === "number" ? value : NaN;
    if (Number.isNaN(num) || num < rule.min || num > rule.max) {
      return `Value must be between ${rule.min} and ${rule.max}`;
    }
  }
  return null;
}
